import ReactPlayer from 'react-player';
import { useResourceBlob } from '../hooks/use-resource-url';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';

export default function VideoPlayer({ url, children, width, height }) {
  const { data: video, loading } = useResourceBlob(url);

  return (
    <Stack spacing={3}>
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress color="inherit" />
          <Typography>Video is downloading</Typography>
        </Box>
      )}
      {video && (
        <Box>
          <ReactPlayer
            style={{ margin: 'auto' }}
            height={height}
            width={width}
            controls={true}
            url={video}
          />
        </Box>
      )}
      {children}
    </Stack>
  );
}
